import React from 'react';

type StatusType =
  | 'paid' |'pending' |'overdue' |'draft' |'sent' |'completed' |'in-progress' |'upcoming' |'discovery' |'design' |'procurement' |'construction' |'finishing' |'handover' |'active' |'on-hold';

interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md';
}

const statusConfig: Record<StatusType, { label: string; className: string; dot: string }> = {
  paid: { label: 'Paid', className: 'bg-positive-bg text-positive', dot: 'bg-positive' },
  pending: { label: 'Pending', className: 'bg-warning-bg text-warning', dot: 'bg-warning' },
  overdue: { label: 'Overdue', className: 'bg-negative-bg text-negative', dot: 'bg-negative' },
  draft: { label: 'Draft', className: 'bg-muted text-muted-foreground', dot: 'bg-muted-foreground' },
  sent: { label: 'Sent', className: 'bg-info-bg text-info', dot: 'bg-info' },
  completed: { label: 'Completed', className: 'bg-positive-bg text-positive', dot: 'bg-positive' },
  'in-progress': { label: 'In Progress', className: 'bg-info-bg text-info', dot: 'bg-info' },
  upcoming: { label: 'Upcoming', className: 'bg-muted text-muted-foreground', dot: 'bg-muted-foreground' },
  discovery: { label: 'Discovery', className: 'bg-secondary text-secondary-foreground', dot: 'bg-secondary-foreground' },
  design: { label: 'Design', className: 'bg-info-bg text-info', dot: 'bg-info' },
  procurement: { label: 'Procurement', className: 'bg-warning-bg text-warning', dot: 'bg-warning' },
  construction: { label: 'Construction', className: 'bg-secondary text-secondary-foreground', dot: 'bg-secondary-foreground' },
  finishing: { label: 'Finishing', className: 'bg-positive-bg text-positive', dot: 'bg-positive' },
  handover: { label: 'Handover', className: 'bg-positive-bg text-positive', dot: 'bg-positive' },
  active: { label: 'Active', className: 'bg-positive-bg text-positive', dot: 'bg-positive' },
  'on-hold': { label: 'On Hold', className: 'bg-warning-bg text-warning', dot: 'bg-warning' },
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.draft;
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${sizeClass} ${config.className}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} />
      {config.label}
    </span>
  );
}